import { forwardRef } from 'react';
import MuiTableSortLabel, { TableSortLabelProps } from '@mui/material/TableSortLabel';
import ArrowDownward from '@o2/icons/ArrowDownward';

export type { TableSortLabelProps };

const TableSortLabel = forwardRef<HTMLDivElement | HTMLSpanElement, TableSortLabelProps>((props, ref) => {
  return <MuiTableSortLabel ref={ref} IconComponent={(props) => <ArrowDownward {...props} />} {...props} />;
});

TableSortLabel.displayName = 'TableSortLabel';

export default TableSortLabel;
